import { thor } from "../../typings/thor";
import { Enums } from "../../thor.enums";
import { LokiOrganizationDialogBaseController, STATUS_DEFAULT } from "./organization-dialog-base.controller";

export class LokiCreateOrganizationDialogController extends LokiOrganizationDialogBaseController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$translate",
        "organizationService",
        "sitesService",
        "toaster"
    ];

    public organization;

    constructor(
        private $log: ng.ILogService,
        protected $mdDialog: ng.material.IDialogService,
        $translate,
        private organizationService,
        sitesService,
        private toaster
    ) {
        super($mdDialog, $translate);

        this.organization = {
            names: {
                judicial: ""
            },
            estimates: {
                accept: false,
                advert: false
            },
            options: {
                taxes: {
                    judicial: ""
                }
            },
            agreement: "",
            address: {},
            authorized_sites: [sitesService.isAuctionDomain() ? Enums.Site.Auction : Enums.Site.Interencheres],
            status: STATUS_DEFAULT
        };
    }

    public create(form) {
        if (form.$valid) {
            this.organizationService
                .create(this.organization)
                .then((organization: thor.Organization) => this.$mdDialog.hide(organization))
                .catch(error => {
                    this.toaster.show(this.$t("une_erreur_est_survenue_creation_impossible"), true);
                    this.$log.error(error);
                });
        }
    }
}
